<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Dermatology</h2>
      <p>
        Diagnosis and treatment of all common dermatological diseases .
        Facilities for cosmetology.
      </p>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate2.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Dermatology Doctors",
      queryName: "Dermatology",
      teamName: "Dermatology team",
    };
  },
  components: { DoctorsList },
});
</script>

<style scoped lang="scss">
@import "@/scss/sectionTemplate2.scss";
</style>
